import { RoutingPanelSlider } from 'features/routing-panel/types'
import { FC } from 'react'
import styled, { useTheme } from 'styled-components'
import { Slide, Slider } from 'ui/slider'

import { CardFilter } from './CardFilter'
import { useScrollToActiveCard } from './useScrollToActiveCard'

export const PanelSlider: FC<RoutingPanelSlider> = ({ showCarsCount, sliderConfig, cards, imagesSettings }) => {
  const { groupToScroll, onActiveChangeHandler } = useScrollToActiveCard({ breakpoints: sliderConfig.breakpoints })
  const theme = useTheme()
  const containerGutters = theme.grid.containerGutters
  const paddingForSliderOverflow = `calc(${containerGutters} / 2 - ${useTheme().spacing[4]})`

  return (
    <SliderWrapper>
      <Slider
        slidesPerPage={sliderConfig.breakpoints}
        paddingForOverflow={paddingForSliderOverflow}
        activeGroup={groupToScroll}
        showArrows={sliderConfig.navigation}
        arrowPosition={theme.spacing[11]}
        showOverflowedSlides={false}
      >
        {cards.map((card, index) => (
          <Slide key={index}>
            <CardFilter {...card} onActiveChange={onActiveChangeHandler(index)} showCarsCount={showCarsCount} />
          </Slide>
        ))}
      </Slider>
    </SliderWrapper>
  )
}

const SliderWrapper = styled.div`
  margin: ${({ theme }) => `${theme.spacing[14]} calc(${theme.grid.containerGutters} / 2 * -1) 0`};
`
